

import Vue from 'vue'
import FastClick from 'fastclick'
import router from "./router";
import App from './App'
import store from "./store/index";
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'

ElementUI.Select.computed.readonly = function () {

const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));

return !(this.filterable || this.multiple || !isIE) && !this.visible;
};


Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
import './assets/style.css';
Vue.use(WechatPlugin)
Vue.use(AjaxPlugin)
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.filter('formatDateTime', function (value) {
if(value){
let d = new Date(parseInt(value)),
year = d.getFullYear(),
month = (d.getMonth()+1) <10 ? '0' + (d.getMonth()+1) : '' + (d.getMonth()+1),
day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate(),
hour = d.getHours() <10 ? '0' + d.getHours() : '' + d.getHours(),
minutes = d.getMinutes() <10 ? '0' + d.getMinutes() : '' + d.getMinutes(),
seconds = d.getSeconds() <10 ? '0' + d.getSeconds() : '' + d.getSeconds();
return  year+ '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
}
});

new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js